import { render, staticRenderFns } from "./ObjectSelection.vue?vue&type=template&id=66996e26&scoped=true"
import script from "./ObjectSelection.vue?vue&type=script&lang=js"
export * from "./ObjectSelection.vue?vue&type=script&lang=js"
import style0 from "./ObjectSelection.vue?vue&type=style&index=0&id=66996e26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66996e26",
  null
  
)

export default component.exports